import {
    SearchCriteria as SearchCriteriaBase,
    SearchResults as SearchResultsBase,
    SearchState as SearchStateBase,
} from "@relode/core";
import { jobs } from "../../../../shared/backend/controllers";

export type SearchState = SearchStateBase<
    jobs.JobSearchRequest,
    jobs.JobSearchResponse
>;

export type SearchCriteria = SearchCriteriaBase<jobs.JobSearchRequest>;
export type SearchResults = SearchResultsBase<jobs.JobSearchResponse>;

export const initialJobSearchState: SearchState = {
    hasError: false,
    error: undefined,
    searching: false,
    isRefined: false,
    searchCriteria: {
        pageIndex: 1,
        pageSize: 25,
    },
    searchResults: {} as Required<Partial<jobs.JobSearchResponse>>,
};
